import { render, staticRenderFns } from "./PrivateKifu.vue?vue&type=template&id=741db593&scoped=true&"
import script from "./PrivateKifu.vue?vue&type=script&lang=js&"
export * from "./PrivateKifu.vue?vue&type=script&lang=js&"
import style0 from "./PrivateKifu.vue?vue&type=style&index=0&id=741db593&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741db593",
  null
  
)

export default component.exports